export const openInNewTab = (link: string): void => {
	window.open(link, '_blank');
};
